<div class="general-snackbar" *ngIf="data">
  <div class="info mat-body-1">
    <fa-icon [icon]="data.icon" *ngIf="data.icon"></fa-icon>
    {{ data.message }}
  </div>
</div>
